import {
  AdvantagesSection,
  // DiscoverSection,
  ElevatingSection,
  HeroSection,
  MapSection,
  NewSection,
  PracticeSection,
  RealStoriesSection,
  FAQSection,
} from "@/components/home";
import { useEffect, useState } from "react";
import { IHomePage } from "@/cms-models/home";
import { NextRouter, useRouter } from "next/router";
import axios from "axios";
import Head from "next/head";
import { NeedMoreHelpSection } from "@/components/about-us";
import { IAboutPage } from "@/cms-models/about";
export default function Home() {
  const router: NextRouter = useRouter();

  const [data, setData] = useState<IHomePage>({} as IHomePage);
  const [aboutData, setAboutData] = useState<IAboutPage>({} as IAboutPage);
  const [globalData, setGlobalData] = useState<IHomePage | null>(null);

  const url = `/${router.locale}/${
    router.locale === "global" ? "globalpage-content" : "homepage-content"
  }/1`;
  const globalUrl = `/${router.locale}/globalpage-content/1`;

  useEffect(() => {
    if (!router.isReady) return;

    const fetchData = async () => {
      try {
        const pageResponse = axios(url);
        const globalResponse =
          router.locale === "en-us" ? axios(globalUrl) : null;

        const [pageData, globalPageData] = await Promise.all([
          pageResponse,
          globalResponse,
        ]);

        if (pageData.status === 200) {
          setData(pageData.data);
        }

        if (globalPageData?.status === 200) {
          setGlobalData(globalPageData.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchAboutData = async () => {
      try {
        const [response] = await Promise.all([
          axios.get(`/${router.locale}/about-content/1`),
        ]);
        if (response.status === 200) {
          setAboutData(response.data);
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (error) { }
    };

    fetchData();
    fetchAboutData();
  }, [router.locale, router.isReady, globalUrl, url]);

  if (!data || Object.keys(data).length === 0) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex flex-col gap-0 md:gap-20">
      <Head>
        <title>Global Home - Premier Vet Alliance</title>
        <link rel="canonical" href="https://premiervetalliance.com/"></link>
        <meta property="og:locale" content="en_US" />
        <meta
          property="og:title"
          content="Global Home - Premier Vet Alliance"
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Premier Vet Alliance" />
        <meta property="og:updated_time" content="2023-11-14T11:25:01+00:00" />
      </Head>
      <HeroSection data={data} globaldata={globalData} />
      <ElevatingSection data={data} />
      <PracticeSection data={data} />
      <AdvantagesSection data={data} />
      <RealStoriesSection data={data} />
      <MapSection data={data} />
      <NewSection title={data.section7_title} />
      <FAQSection data={data.questions} />
      <NeedMoreHelpSection
        title={aboutData.section6_title}
        description={aboutData.section6_description}
        msgTitle={aboutData.section6_msg_title}
        msgDescription={aboutData.section6_msg_content}
        msgIcon={aboutData.section6_msg_icon}
        phoneTitle={aboutData.section6_phone_title}
        phoneDescription={aboutData.section6_phone_content}
        phoneIcon={aboutData.section6_phone_icon}
        // image={data.section4_image}
      />
      {/* <DiscoverSection
        title={data.section9_title}
        description={data.section9_description}
        image={data.section9_image}
      /> */}
    </div>
  );
}
